import { Capacitor, registerPlugin } from '@capacitor/core';
import { Preferences } from '@capacitor/preferences';

interface SharedPreferencesPlugin {
  set(options: { key: string; value: string }): Promise<void>;
  get(options: { key: string }): Promise<{ value: string | null }>;
  remove(options: { key: string }): Promise<void>;
}

let SharedPreferences: SharedPreferencesPlugin | null = null;

if (Capacitor.getPlatform() === 'ios') {
  SharedPreferences = registerPlugin<SharedPreferencesPlugin>('SharedPreferences');
}

export const setSharedPreference = async (key: string, value: string): Promise<void> => {
  await Preferences.set({ key, value });

  if (SharedPreferences) {
    try {
      await SharedPreferences.set({ key, value });
    } catch (error) {
      console.error('Failed to write to SharedPreferences:', error);
    }
  }
};

export const removeSharedPreference = async (key: string): Promise<void> => {
  await Preferences.remove({ key });

  if (SharedPreferences) {
    try {
      await SharedPreferences.remove({ key });
    } catch (error) {
      console.error('Failed to remove from SharedPreferences:', error);
    }
  }
};
